<template>
  <div :class="$style.policyContainer">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.bannerImg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="22.5" cy="22.5" r="22.5" fill="#F8EED9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.165 15.943a37.724 37.724 0 018.517-1.42v8.517H14.07a8.23 8.23 0 01-.258-.903 22.897 22.897 0 01-.646-6.194zm8.517 7.228v8.258a12.1 12.1 0 007.743-8.258h-7.743z" fill="#FFB000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.683 10.91h.517v.005a41.47 41.47 0 0111.098 1.677s3.87 17.808-11.615 22.453C6.713 31.17 9.811 13.103 9.811 13.103a45.926 45.926 0 0111.872-2.194zm10.583 2.838A35.42 35.42 0 0022.2 12.199h-.645a47.21 47.21 0 00-10.84 1.936c-.259 3.356-1.033 16.518 10.84 19.873a14.56 14.56 0 0010.582-11.873c.562-2.763.605-5.608.129-8.387z" fill="#FFB000"/></svg>
    <div :class="$style.policyMessage">
      <div :class="$style.policyHeader">
        JumpCloud MDM Enrollment {{ configurationItem.title }}
      </div>
      <div :class="$style.policyDescription">
        Remotely enroll {{ deviceItem.labelPlural }} in JumpCloud's MDM across your organization.
      </div>
    </div>
    <div :class="$style.policyAction">
      <FlatActionAnchor
        :href="configurationItem.route"
        target="_self"
        :text="`go to ${configurationItem.labelPlural}`"
      />
    </div>
  </div>
</template>

<script>
import FlatActionAnchor from 'client/components/Buttons/FlatActionAnchor';
import ItemType from 'client/util/Constants/ItemType';

const { ConfigurationItemType, DeviceItemType } = ItemType;
const configurationItem = new ConfigurationItemType();
const deviceItem = new DeviceItemType();

export default {
  name: 'MdmPolicyBanner',

  components: {
    FlatActionAnchor,
  },

  data() {
    return {
      configurationItem,
      deviceItem,
    };
  },
};
</script>

<style module>
@value (jcGrey200) from '~css/brand-colors.css';

.bannerImg {
  height: 45px;
  margin-right: 40px;
  width: 45px;
}

.policyContainer {
  align-items: center;
  background-color: white;
  border: 1px solid jcGrey200;
  border-radius: 5px;
  display: flex;
  margin: 10px 20px;
  padding: 20px 20px;
}

.policyHeader {
  font-size: 18px;
  font-weight: bold;
  max-width: 700px;
  min-width: 230px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.policyMessage {
  font-size: 14px;
  max-width: 700px;
  min-width: 140px;
  text-align: left;
}

.policyDescription {
  margin-top: 5px;
}

.policyAction {
  cursor: pointer;
  flex: auto;
  min-width: fit-content;
  text-align: right;
}
</style>
